import { createSlice } from "@reduxjs/toolkit";
import sharedDataApi from "../../api/sharedDataApi";
import { setLoading, setToast } from "../../app/appSlice";
import {
  getCurrentDate,
  compareByModelNumber,
  createXLSXSheet,
  int16ToByte,
} from "../../utilities/helperMethods";
import { productApi } from "../../api/productApi";
import Constants from "../../utilities/constants";
// import { API } from "aws-amplify";
// import { insertSdpCoolCloudData } from "../../graphql/mutations";
// import { useParams } from 'react-router-dom'
// import msalInstance from "../../app/msal";
// import { apiTokenRequest } from "../../authConfig";
export const sDActions = Object.freeze({
  updateSharedData: "Update Shared Data",
  deleteSharedData: "Delete Shared Data",
});

export const sdStates = Object.freeze({
  draft: "Draft",
  inReview: "In_Review",
  staging: "Staging",
  preProd: "Pre_Prod",
  production: "Production",
});


export const actionItemStatus = Object.freeze({
    draft: "DRAFT",
    inReview: "IN_REVIEW",
    approved: "APPROVED",
    rejected: "REJECTED"
  });

export const sharedDataSlice = createSlice({
  name: "sharedData",
  initialState: {
    recipeData: [],
    sdUserData: [],
    availableSdInputStates: [],
    productData: {},
    lookupOptions: {},
    formInputValues: {},
    existingInputValues: {},
    sdModal: {
      isOpen: false,
      type: null,
      revisionNumber: [],
    },
    previousModelRevisions: [],
    previousModelRevisionsSdUserInputs: [],
    clonedFrom: {},
  },
  reducers: {
    resetFormInputValues: (state) => {
      state.formInputValues = {};
      state.existingInputValues = {};
      state.sdUserData = [];
      state.clonedFrom = {};
      state.recipeData = [];
    },
    setSdUserData: (state, action) => {
      const { payload } = action;
      state.sdUserData = payload;
    },
    setRecipeData: (state, action) => {
      const { payload } = action;
      state.recipeData = payload;
    },
    setAvailableSdInputStates: (state, action) => {
      const { payload } = action;
      state.availableSdInputStates = payload;
    },
    setLookupOptions: (state, action) => {
      const { payload } = action;
      state.lookupOptions = payload;
    },
    setProductData: (state, action) => {
      const { payload } = action;
      state.productData = payload;
    },
    setSdModal: (state, action) => {
      const { payload } = action;
      state.sdModal = payload;
    },
    setFormInputValues: (state, action) => {
      const { payload } = action;
      state.formInputValues = payload;
    },
    setExistingInputValues: (state, action) => {
      const { payload } = action;
      state.existingInputValues = payload;
    },
    setPreviousModelRevisions: (state, action) => {
      const { payload } = action;
      state.previousModelRevisions = payload;
    },
    setPreviousModelRevisionsSdUserInputs: (state, action) => {
      const { payload } = action;
      let prevSdInputs = [];
      if (Object.keys(payload).length > 0) {
        prevSdInputs = [...state.previousModelRevisionsSdUserInputs, payload];
      }
      state.previousModelRevisionsSdUserInputs = prevSdInputs;
    },
    setClonedFrom: (state, action) => {
      const { payload } = action;
      state.clonedFrom = payload;
    },
  },
});

export const downloadSharedData = (param) => async (dispatch, getState) => {
  const currSdState = param;
  const currState = getState().sharedData;

  const productData = currState.productData;
  const recipe = currState.recipeData; // => stringify it
  const userInput = currState.formInputValues;
  dispatch(setLoading({ isLoading: true }));
  const params = {
    productInfo: JSON.stringify(productData),
    recipe: JSON.stringify(recipe),
    userInput: JSON.stringify(userInput),
    state: currSdState,
    downloadSd: true,
  };
  const payload = await sharedDataApi.generateSharedData(params);

  // Filter out JsonByteMatch fields for Excel generation
  const filteredRecipe = recipe.filter((field) => field.type !== "JsonByteMatch");
  const filteredPayload = payload.filter((_, index) => recipe[index].type !== "JsonByteMatch");

  createXLSXSheet({
    userInput,
    template: filteredRecipe,
    payload:filteredPayload,
    state: currSdState,
    productData,
  });
  dispatch(setLoading({ isLoading: false }));
};

// function transformDataFormat(data) {
//   return {
//     id: data.id,
//     control_id: data.control_id,
//     createdAt: data.createdAt,
//     createdTime: data.createdTime,
//     deleted: data.deleted,
//     display_value:
//       typeof data.display_value === "string"
//         ? data.display_value
//         : JSON.stringify(data.display_value),
//     first_part: data.first_part,
//     last_part: data.last_part,
//     middle_part: data.middle_part,
//     model_number: data.model_number,
//     second_part: data.second_part,
//     shareddata_version: data.shareddata_version,
//     software_version: data.software_version,
//     updatedAt: data.updatedAt,
//     updatedTime: data.updatedTime,
//     _lastChangedAt: data._lastChangedAt,
//     _version: data._version,
//     __typename: data.__typename,
//   };
// }

// const FIELD_NAMES = {
//   DATAAC_CONTROL_ID: ["dataac control id", "Control ID"],
//   BYTES_IN_SHARED_DATA: "bytes in shared data",
//   UNIT_MODEL: "unit model",
//   UNIT_SERIAL: "unit serial",
//   CHECKSUM_UPTO_MODIFIED: "checksum of all shared data upto modified field",
//   CHECKSUM_MODIFIED: "checksum modified data field",
//   CHECKSUM_LOW_BYTE: "checksum data field low byte",
// };

// // Action to generate Cool Cloud data by calling the generateCoolCloudData lambda function
// export const generateCoolCloudData = (param) => async (dispatch, getState) => {
//   const currSdState = param;
//   const currState = getState().sharedData;

//   const {
//     productData,
//     recipeData: recipe,
//     formInputValues: userInput,
//   } = currState;

//   dispatch(setLoading({ isLoading: true }));

//   try {
//     // Get access token from MSAL
//     let tokenResponse;
//     try {
//       tokenResponse = await msalInstance.acquireTokenSilent({
//         ...apiTokenRequest,
//         account: msalInstance.getAllAccounts()[0],
//       });
//     } catch (error) {
//       tokenResponse = await msalInstance.acquireTokenPopup({
//         ...apiTokenRequest,
//         account: msalInstance.getAllAccounts()[0],
//       });
//     }

//     const params = {
//       productInfo: JSON.stringify(productData),
//       recipe: JSON.stringify(recipe),
//       userInput: JSON.stringify(userInput),
//       state: currSdState,
//       downloadSd: true,
//       accessToken: tokenResponse.accessToken,
//     };
    
//     // Call the lambda function via GraphQL
//     const result = await sharedDataApi.generateCoolCloudData(params);
    
//     // Parse the lambda response body if it's in HTTP response format
//     let parsedResult = result;
//     if (result && result.body && typeof result.body === 'string') {
//       parsedResult = JSON.parse(result.body);
//     } else if (typeof result === 'string') {
//       const firstParse = JSON.parse(result);
//       if (firstParse && firstParse.body && typeof firstParse.body === 'string') {
//         parsedResult = JSON.parse(firstParse.body);
//       } else {
//         parsedResult = firstParse;
//       }
//     }
    
//     if (parsedResult && parsedResult.data) {
//       const formattedData = parsedResult.data;
      
//       // Update product with CoolCloudDBAck flag
//     const updatedProduct = {
//       id: productData.id,
//       CoolCloudDBAck: true,
//       ModelNumber: productData.ModelNumber,
//       State: productData.State,
//       SdAvailable: productData.SdAvailable,
//     };
//     const updateProductData = await productApi.updateProduct({
//       updatedProduct,
//     });    
//     dispatch(sharedDataSlice.actions.setProductData(updateProductData)); 

//     // Download the JSON file
//     downloadJson(formattedData);
//    alert("Success: Data successfully inserted into the CoolCloud App DB!");
      
//    return formattedData;
//  } else {
//    throw new Error('No data received from Lambda function');
//  }
    
//   } catch (error) {
//     console.error('Error calling generateCoolCloudData:', error);
    
//     // Handle different types of errors
//     let errorMessage = 'Data insertion failed.';
    
//     if (error.response?.status === 401) {
//       errorMessage = 'Authentication failed. Please login again.';
//       // Optionally trigger re-authentication here
//     } else if (error.response?.status === 403) {
//       errorMessage = 'Access denied. You do not have permission to perform this action.';
//     } else if (error.message) {
//       errorMessage = `Data insertion failed. ${error.message}`;
//     }
    
//     alert(`Error: ${errorMessage}`);
//     throw new Error(error);
//   } finally {
//     dispatch(setLoading({ isLoading: false }));
//   }
// };

// // Updated downloadJsonSharedData to use the lambda function
// export const downloadJsonSharedData = (param) => async (dispatch, getState) => {
//   try {
//     // Use the generateCoolCloudData function which handles everything
//     await dispatch(generateCoolCloudData(param));
//   } catch (error) {
//     console.error("Error calling generateCoolCloudData:", error);
//     throw new Error(error);
//   }
// };

// Download JSON file
// const downloadJson = (dataToDownload) => {
//   try {
//     if (!dataToDownload) {
//       throw new Error("No data provided for download");
//     }
    
//     const jsonBlob = new Blob([JSON.stringify(dataToDownload, null, 2)], {
//       type: "application/json",
//     });
    
//     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
//       window.navigator.msSaveOrOpenBlob(jsonBlob, "sharedData.json");
//     } else {
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(jsonBlob);
//       link.download = "sharedData.json";
//       document.body.appendChild(link);
//       link.click();
//       setTimeout(() => {
//         document.body.removeChild(link);
//         URL.revokeObjectURL(link.href);
//       }, 100);
//     }
//   } catch (err) {
//     console.error("Download JSON error:", err);
//     throw new Error(`Failed to download JSON file: ${err.message}`);
//   }
// };

export const getSharedDataUserInputs =
  (payload) => async (dispatch, getState) => {
    const currSdState = payload;
    const storeState = getState().sharedData;

    const paramId = new URLSearchParams(window.location.search);
    const id = paramId.get('id');

    dispatch(setLoading({ isLoading: true }));

    try {
      const params = {
        ModelNumber: storeState.productData.ModelNumber,
        State: { eq: currSdState },
        limit: 10000,
      };

      if (
        currSdState === sdStates.staging ||
        currSdState === sdStates.production
      ) {
        const versionField = `${currSdState}Version`;
        params.filter = {
          Version: { eq: storeState.productData[versionField] },
        };
      }

      const userInputs = await sharedDataApi.fetchModelNumberByState(params);
      const matchedItem = userInputs.items.find(item => item.id === id);

      if (matchedItem) {
        dispatch(sharedDataSlice.actions.setSdUserData([matchedItem]));
      } else {
        dispatch(sharedDataSlice.actions.setSdUserData([]));
        console.warn("No matching item found for ID:", id);
      }

    } catch (error) {
      throw error;
    } finally {
      dispatch(setLoading({ isLoading: false }));
    }
  };
  
export const getProductInfoById = (payload) => async (dispatch) => {
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  dispatch(setLoading({ isLoading: true }));
  let retriesLeft = 3;

  try {
    while (retriesLeft > 0) {
      const productInfo = await productApi.searchProducts({
        filter: { id: { eq: payload } },
      });

      if (productInfo?.items?.length > 0) {
        dispatch(sharedDataSlice.actions.setProductData(productInfo.items[0]));
        dispatch(setLoading({ isLoading: false }));
        return;
      }

      retriesLeft--;

      if (retriesLeft === 0) {
        throw new Error(`No products found for id: ${payload}`);
      }

      // Add delay before the next request
      await delay(1000);
    }
  } catch (error) {
    dispatch(setLoading({ isLoading: false }));
    throw error;
  }
};
export const getAvailableSdInputStates =
  (payload) => async (dispatch, getState) => {
    const storeState = getState().sharedData;
    dispatch(setLoading({ isLoading: true }));
    let stagVersion = 0;
    let prodVersion = 0;
    if (storeState.productData.StagingVersion) {
      stagVersion = storeState.productData.StagingVersion;
    }
    if (storeState.productData.ProductionVersion) {
      prodVersion = storeState.productData.ProductionVersion;
    }
    const params = {
      filter: {
        or: [
          {
            State: {
              eq: sdStates.production,
            },
            Version: {
              eq: prodVersion,
            },
            id: {
              eq: storeState.productData.id,
            },
          },
          {
            State: {
              eq: sdStates.staging,
            },
            Version: {
              eq: stagVersion,
            },
            id: {
              eq: storeState.productData.id,
            },
          },
          {
            State: {
              eq: sdStates.draft,
            },
            ModelNumber: {
              eq: storeState.productData.ModelNumber,
            },
          },
        ],
      },
      limit: 1000000,
    };
    const userInputs = await sharedDataApi.fetchUserInputs(params);
    dispatch(
      sharedDataSlice.actions.setAvailableSdInputStates(userInputs.items)
    );
    dispatch(setLoading({ isLoading: false }));
  };

export const getRecipeTemplate = (payload) => async (dispatch) => {
  dispatch(setLoading({ isLoading: true }));
  try {
    const params = {
      Name: payload,
    };
    const recipeTemplateData = await sharedDataApi.getRecipeTemplate(params);
    const template = JSON.parse(recipeTemplateData.Recipe);
    dispatch(sharedDataSlice.actions.setRecipeData(template));
    dispatch(setLoading({ isLoading: false }));
  } catch (error) {
    dispatch(setLoading({ isLoading: false }));
    throw error;
  }
};

export const getLookupOptions = (payload) => async (dispatch) => {
  dispatch(setLoading({ isLoading: true }));
  const lookupsData = await sharedDataApi.fetchLookupOptions();
  const lookupsObj = lookupsData.items.reduce((result, item) => {
    const { Name, Options } = item;
    if (!result[Name]) {
      result[Name] = [];
    }
    const options = JSON.parse(Options);
    const optionsKey = Object.keys(options);
    optionsKey.forEach((data) => {
      result[Name].push({
        value: options[data],
        label: data,
      });
    });
    return result;
  }, {});
  dispatch(sharedDataSlice.actions.setLookupOptions(lookupsObj));
  dispatch(setLoading({ isLoading: false }));
};

const findPreviousModelRevisionsByState = async (
  modelNumber,
  state,
  dispatch
) => {
  const modelNumberData = { ModelNumber: modelNumber };
  const wildCardPattern = modelNumber.slice(0, -2) + "*";
  let filterData;
  if (state === sdStates.staging) {
    filterData = {
      or: [
        {
          ModelNumber: { wildcard: wildCardPattern },
          State: { eq: sdStates.staging },
        },
        {
          ModelNumber: { wildcard: wildCardPattern },
          State: { eq: sdStates.production },
        },
      ],
    };
  } else {
    filterData = {
      ModelNumber: { wildcard: wildCardPattern },
      State: { eq: sdStates.production },
    };
  }
  const params = {
    filter: filterData,
    limit: 10000,
  };

  const productModelRevisionInfo = await productApi.searchProducts(params);
  const revisionNumbersInfo = productModelRevisionInfo.items;
  const modelNumberIdx = revisionNumbersInfo.findIndex(
    (item) => item.ModelNumber === modelNumber
  );
  if (modelNumberIdx === -1) {
    revisionNumbersInfo.push(modelNumberData);
  }
  revisionNumbersInfo.sort(compareByModelNumber);
  const modelNumberIndex = revisionNumbersInfo.findIndex(
    (item) => item.ModelNumber === modelNumber
  );

  const previousModalRevisions = revisionNumbersInfo.filter(
    (_, index) => index < modelNumberIndex
  );
  dispatch(
    sharedDataSlice.actions.setPreviousModelRevisions(previousModalRevisions)
  );
  dispatch(sharedDataSlice.actions.setPreviousModelRevisionsSdUserInputs({}));
  return previousModalRevisions;
};

const showPopup = async (state, dispatch, previousModalRevisionList) => {
  dispatch(
    sharedDataSlice.actions.setSdModal({
      isOpen: true,
      type: state,
      revisionNumber:
        previousModalRevisionList.length > 0 ? previousModalRevisionList : [],
    })
  );
};

export const handleSaveForm = (payload) => async (dispatch, getState) => {
  const { state } = payload;
  const storeState = getState().sharedData;
  let previousModalRevisionList = [];
  if (state === sdStates.staging || state === sdStates.production) {
    const modelRevisionsList = await findPreviousModelRevisionsByState(
      storeState.productData.ModelNumber,
      state,
      dispatch
    );
    previousModalRevisionList.push(...modelRevisionsList);
  }
  showPopup(state, dispatch, previousModalRevisionList);
};

  /** Private helper for    — saves to the sdUserInputs table. */
  const saveSdUserInput = async ({ action, saveToState, reasonForChange, storeState, dispatch }) => {
    if (action === "createSD") {
      const params = {
        input: {
          State: saveToState,
          ModelNumber: storeState.productData.ModelNumber,
          Input: JSON.stringify(storeState.formInputValues),
          Version: 1,
          ReasonForChange: reasonForChange,
        },
      };
    const createSdData = await sharedDataApi.createSdUserInputs(params);
    dispatch(sharedDataSlice.actions.setSdUserData([createSdData]));

    const updatedProduct = {
      id: storeState.productData.id,
      ModelNumber: storeState.productData.ModelNumber,
      State: sdStates.draft,
      SdAvailable: true,
    };
    const updateProductData = await productApi.updateProduct({ updatedProduct });
    dispatch(sharedDataSlice.actions.setProductData(updateProductData));
  } else {
    const userInput = {
      ...storeState.existingInputValues,
      ...storeState.formInputValues,
    };
    const params = {
      input: {
        id: storeState.sdUserData[0].id,
        ModelNumber: storeState.productData.ModelNumber,
        Input: JSON.stringify(userInput),
        ReasonForChange: reasonForChange,
      },
    };
    const updateSdData = await sharedDataApi.updateSdUserInputs(params);
    dispatch(sharedDataSlice.actions.setSdUserData([updateSdData]));
  }
};

export const handleDraftPopup = (payload) => async (dispatch, getState) => {
  const { action, saveToState, emailInfo, reasonForChange, onSuccess } = payload;
  const storeState = getState().sharedData;
  const userStoreState = getState().app.user;
  dispatch(setLoading({ isLoading: true }));
  try {
    await saveSdUserInput({ action, saveToState, reasonForChange, storeState, dispatch });

    await sendEmailNotification(
      userStoreState,
      reasonForChange,
      sdStates.draft,
      storeState,
      emailInfo.emails
    );

    dismissModalAndShowToast(dispatch, `Saved to Draft successfully`, onSuccess);
  } catch (error) {
    dismissModalAndShowToast(dispatch, error.message || "Error! Failed to save the data.");
  }
};

export const handleSaveToActionItems =
  (payload) => async (dispatch, getState) => {
    const { input, saveToState, onSuccess, onAbort } = payload;
    const storeState = getState().sharedData;
    const userStoreState = getState().app.user;
    dispatch(setLoading({ isLoading: true }));
    try {
      const { productData: productInfo, formInputValues: formInputs, clonedFrom: cloneFromStoreData = {} } = storeState;
      const productExists = await doesProductExist(productInfo.id);
       if (!productExists) {
         dismissModalAndShowToast(
           dispatch,
           "This product was deleted by another user. Please refresh the page."
         );
         return;
       }

      const reviewers = resolveReviewers(formInputs);

      const [existingItem] = await fetchExistingActionItem(productInfo.id);

      // Prevent overwriting if another user already submitted this product for review
      if (
        existingItem &&
        existingItem.Status === actionItemStatus.inReview &&
        existingItem.CreatedByEmail?.toLowerCase() !== userStoreState?.email?.toLowerCase()
      ) {
        dismissModalAndShowToast(
          dispatch,
          `This product has already been submitted for review by ${existingItem.CreatedByEmail}.`,
          onAbort
        );
        return;
      }

      // Always submit as IN_REVIEW when the caller intends to submit for review
      const isSubmitForReview =
        saveToState &&
        saveToState.toLowerCase() === 'staging' &&
        input?.reasonForChange;
      const effectiveState = isSubmitForReview ? sdStates.inReview : saveToState;


      const sdInput = storeState.availableSdInputStates.find(
        (s) => s.State === productInfo.State
      );

      await createOrUpdateActionItem({
        existingItem: existingItem || null,
        productInfo,
        formInputs,
        reviewers,
        status: actionItemStatus.inReview,
        state: effectiveState,
        currentUser: userStoreState,
        cloneFromStoreData,
        extraFields: {
          ReasonForChange: input?.reasonForChange || existingItem?.ReasonForChange || '',
          Version: sdInput ? sdInput.Version : 0,
          CreatedByEmail: userStoreState?.email || '',
        },
      });

      await updateProductState(productInfo, sdStates.inReview);

      try {
        await sendEmailNotification(
          userStoreState,
          input.reasonForChange,
          saveToState,
          storeState
        );
      } catch (error) {
        throw new Error("Data saved but failed to send email");
      }

      dismissModalAndShowToast(
        dispatch,
        `Product submitted for review successfully`,
        onSuccess
      );
    } catch (error) {
      dismissModalAndShowToast(
        dispatch,
        error.message || `Error! Failed to save to Action Item with status ${saveToState}`
      );
    }
  };

// export const handleStagAndProdPopup =
//   (payload) => async (dispatch, getState) => {
//     const { input, saveToState, onSuccess } = payload;
//     const storeState = getState().sharedData;
//     const userStoreState = getState().app.user;
//     dispatch(setLoading({ isLoading: true }));
//     let versionNumber;
//     try {
//       if (saveToState === sdStates.staging) {
//         versionNumber = storeState.productData.StagingVersion
//           ? storeState.productData.StagingVersion + 1
//           : 1;
//       } else if (saveToState === sdStates.production) {
//         versionNumber = storeState.productData.ProductionVersion
//           ? storeState.productData.ProductionVersion + 1
//           : 1;
//       }
//       try {
//         if (storeState.productData.State === sdStates.draft) {
//           const params = {
//             input: {
//               id: storeState.sdUserData[0].id,
//               ModelNumber: storeState.productData.ModelNumber,
//               Input: JSON.stringify(storeState.formInputValues),
//               ReasonForChange: input.reasonForChange,
//               State: sdStates.staging,
//               Version: versionNumber,
//             },
//           };
//           await sharedDataApi.updateSdUserInputs(params);
//         } else {
//           const params = {
//             input: {
//               ModelNumber: storeState.productData.ModelNumber,
//               Input: JSON.stringify(storeState.formInputValues),
//               State: saveToState,
//               Version: versionNumber,
//               ReasonForChange: input.reasonForChange,
//             },
//           };
//           await sharedDataApi.createSdUserInputs(params);
//         }
//       } catch (error) {
//         throw new Error("Error! Failed to save the data.");
//       }

//       try {
//         const queryParams = {
//           systems: ["CoolCloud", "DataLoader"],
//           recipe: JSON.stringify(storeState.recipeData),
//           userInput: JSON.stringify(storeState.formInputValues),
//           state: saveToState,
//           productInfo: JSON.stringify(storeState.productData),
//         };
//         await sharedDataApi.deploySdToSystems(queryParams);
//       } catch (error) {
//         throw new Error(`Error! Failed to sync the data to ${saveToState}`);
//       }

//       try {
//         const updatedProduct = {
//           id: storeState.productData.id,
//           ModelNumber: storeState.productData.ModelNumber,
//           SdAvailable: true,
//         };
//         const versionField = `${saveToState}Version`;
//         updatedProduct[versionField] = versionNumber;
//         if (storeState.productData.State !== sdStates.production) {
//           updatedProduct["State"] = saveToState;
//         }
//         await productApi.updateProduct({ updatedProduct });
//       } catch (error) {
//         throw new Error("Error! Failed to update the product.");
//       }
//       try {
//         await sendEmailNotification(
//           userStoreState,
//           input.reasonForChange,
//           saveToState,
//           storeState
//         );
//       } catch (error) {
//         throw new Error("Data saved but failed to send email");
//       }
//       if (input.selectedRevisionNumbers.length > 0) {
//         await saveSelectedModelRevisions(
//           input,
//           saveToState,
//           dispatch,
//           getState
//         );
//       }
//       dismissModalAndShowToast(
//         dispatch,
//         `Saved to ${saveToState} successfully`,
//         onSuccess
//       );
//     } catch (error) {
//       if (error.message) {
//         dismissModalAndShowToast(dispatch, error.message);
//       } else {
//         dismissModalAndShowToast(
//           dispatch,
//           `Error! Failed to save to ${saveToState}`
//         );
//       }
//     }
//   };

export const handleDeleteSd = (payload) => async (dispatch, getState) => {
  const { navigateToProduct } = payload;
  const storeState = getState().sharedData;
  if (storeState.sdUserData[0].State === sdStates.draft) {
    dispatch(setLoading({ isLoading: true }));
    try {
      const params = {
        input: {
          ModelNumber: storeState.productData.ModelNumber,
          id: storeState.sdUserData[0].id,
        },
      };
      await sharedDataApi.deleteSdUserInputs(params);

      const updatedProduct = {
        id: storeState.productData.id,
        ModelNumber: storeState.productData.ModelNumber,
        State: null,
        SdAvailable: false,
      };
      await productApi.updateProduct({
        updatedProduct,
      });
      dismissModalAndShowToast(
        dispatch,
        `Shared data deleted successfully`,
        navigateToProduct
      );
    } catch (error) {
      dismissModalAndShowToast(dispatch, "Error! Failed to delete the data.");
    }
  }
};
// const saveSelectedModelRevisions = async (
//   input,
//   saveToState,
//   dispatch,
//   getState
// ) => {
//   for (let i = 0; i < input.selectedRevisionNumbers.length; i++) {
//     const storeState = getState().sharedData;
//     const productInfo = storeState.previousModelRevisions.filter(
//       (item) => item.ModelNumber === input.selectedRevisionNumbers[i]
//     );
//     if (productInfo.length > 0) {
//       const versionField = `${saveToState}Version`;
//       const versionNumber = productInfo[0][versionField]
//         ? productInfo[0][versionField]
//         : 0;
//       const params = {
//         ModelNumber: input.selectedRevisionNumbers[i],
//         State: { eq: saveToState },
//         filter: {
//           Version: { eq: versionNumber },
//         },
//         limit: 10000,
//       };
//       const sdUserInputResult = await sharedDataApi.fetchModelNumberByState(
//         params
//       );
//       const sdUserInput = sdUserInputResult.items[0];
//       dispatch(
//         sharedDataSlice.actions.setPreviousModelRevisionsSdUserInputs(
//           sdUserInput
//         )
//       );
//       const inputObj = {
//         ...storeState.formInputValues,
//         "Unit Model": input.selectedRevisionNumbers[i],
//       };
//       try {
//         const updateParams = {
//           input: {
//             id: sdUserInput.id,
//             ModelNumber: input.selectedRevisionNumbers[i],
//             Input: JSON.stringify(inputObj),
//             ReasonForChange: input.reasonForChange,
//             State: saveToState,
//             Version: versionNumber + 1,
//           },
//         };
//         await sharedDataApi.updateSdUserInputs(updateParams);
//       } catch (err) {
//         throw new Error(
//           `Error! Failed to update the data for ${input.selectedRevisionNumbers[i]}.`
//         );
//       }

//       try {
//         const queryParams = {
//           systems: ["CoolCloud", "DataLoader"],
//           recipe: JSON.stringify(storeState.recipeData),
//           userInput: JSON.stringify(inputObj),
//           state: saveToState,
//           productInfo: JSON.stringify(productInfo[0]),
//         };
//         await sharedDataApi.deploySdToSystems(queryParams);
//       } catch (error) {
//         throw new Error(
//           `Error! Failed to sync the data to for ${input.selectedRevisionNumbers[i]}`
//         );
//       }

//       try {
//         const updatedProduct = {
//           id: productInfo[0]["id"],
//           ModelNumber: input.selectedRevisionNumbers[i],
//         };
//         updatedProduct[versionField] = versionNumber + 1;
//         await productApi.updateProduct({ updatedProduct });
//       } catch (err) {
//         throw new Error("Error! Failed to update the product data.");
//       }

//       const updatedStoreState = getState().sharedData;
//       const userStoreState = getState().app.user;
//       try {
//         await sendEmailNotification(
//           userStoreState,
//           input.reasonForChange,
//           saveToState,
//           updatedStoreState,
//           [],
//           input.selectedRevisionNumbers[i]
//         );
//       } catch (err) {
//         throw new Error("Data saved but failed to send email");
//       }
//     }
//   }
// };

export const sendSdpEmailNotification = (emailParams) => async (dispatch) => {
  try {
    await sharedDataApi.sendEmails(emailParams);
  } catch (err) {
    console.error("Error while sending SDP email notification:", err);
    throw err;
  }
};

const sendEmailNotification = async (
  userStoreState,
  reasonForChange,
  saveToState,
  storeState,
  emails = [],
  previousModelRevision = null
) => {
  // Collect reviewer emails from ReviewerEmails array if available, else fallback to Reviewer
  let reviewerEmails = [];
  if (Array.isArray(storeState.formInputValues.Reviewer)) {
    reviewerEmails = storeState.formInputValues.Reviewer.map(e => e.toLowerCase());
  } else if (storeState.formInputValues.Reviewer) {
    reviewerEmails = [storeState.formInputValues.Reviewer.toLowerCase()];
  }
  // Merge with any additional emails passed in
  const emailList = Array.from(new Set([...reviewerEmails, ...(emails || []).map(e => e.toLowerCase())]));

  let previousInputValues = {};
  let savedDataTo = "";
  if (previousModelRevision) {
    const previousModelRevisionSdInput =
      storeState.previousModelRevisionsSdUserInputs.filter(
        (item) => item.ModelNumber === previousModelRevision
      );
    if (previousModelRevisionSdInput.length > 0) {
      const revisionModelNumberSdInput = JSON.parse(
        previousModelRevisionSdInput[0].Input
      );
      previousInputValues = { ...revisionModelNumberSdInput };
    }
    savedDataTo = saveToState;
  } else {
    if (
      storeState.sdUserData.length === 0 &&
      (saveToState === sdStates.draft || saveToState === sdStates.staging)
    ) {
      savedDataTo = saveToState;
    } else if (storeState.sdUserData[0].State === saveToState) {
      previousInputValues = { ...storeState.existingInputValues };
      savedDataTo = saveToState;
    } else {
      savedDataTo = `${storeState.sdUserData[0].State} to ${saveToState}`;
      const previousSdInput = storeState.availableSdInputStates.filter(
        (item) => item.State === saveToState
      );
      if (previousSdInput.length > 0) {
        const inputValues = JSON.parse(previousSdInput[0].Input);
        previousInputValues = inputValues;
      }
    }
  }
  const userInputsList = [];
  for (const [key, value] of Object.entries(storeState.recipeData)) {
    if (value.type !== "input") continue;
    if (
      (storeState.formInputValues[value.fieldName] ||
        previousInputValues[value.fieldName]) &&
      storeState.formInputValues[value.fieldName] !==
        previousInputValues[value.fieldName]
    ) {
      if (!(previousModelRevision && value.fieldName === "Unit Model")) {
        const record = {};
        record["name"] = value.fieldName;
        record["previousInput"] = previousInputValues[value.fieldName]
          ? previousInputValues[value.fieldName]
          : "-";
        record["newInput"] = storeState.formInputValues[value.fieldName]
          ? storeState.formInputValues[value.fieldName]
          : "-";
        userInputsList.push(record);
      }
    }
  }

  let reasonComment = '';
  if (reasonForChange) {
    if (typeof reasonForChange === 'string') {
      try {
        const parsed = JSON.parse(reasonForChange);
        if (parsed && parsed.comment) reasonComment = parsed.comment;
      } catch (e) {
        // If not JSON, fallback to using the string itself
        reasonComment = reasonForChange;
      }
    } else if (typeof reasonForChange === 'object' && reasonForChange.comment) {
      reasonComment = reasonForChange.comment;
    }
  }

  // Get the current user's email (performer/creator)
  const userEmail = userStoreState.email?.toLowerCase();

  // For "Submit for CoolCloud Test":
  // From: Creator (current user)
  // To: All Reviewers
  // CC: Creator (performer for visibility)
  const ccEmails = [userEmail].filter(Boolean);

  const templateData = {
    emailSubject: "Submit for CoolCloud test",
    userName: userStoreState.name,
    date: new Date().toLocaleDateString(),
    modelNumber: previousModelRevision
      ? previousModelRevision
      : storeState.productData.ModelNumber,
    reasonForChange: reasonComment,
    userInputs: userInputsList,
    changesDoneTo: "A new product has been submitted for review and CoolCloud Test approval.",
  };
  
  const templateDataWithSender = {
    ...templateData,
    fromEmail: userEmail,
    cc: ccEmails
  };
  
  const emailParams = {
    emails: emailList,
    templateId: Constants.emailTemplateID,
    templateData: JSON.stringify(templateDataWithSender),
  };
  try {
    await sharedDataApi.sendEmails(emailParams);
  } catch (err) {
    console.error("Error while sending email:", err);
    throw err;
  }
};

const dismissModalAndShowToast = (
  dispatch,
  toastMessage,
  navigation = null
) => {
  dispatch(setLoading({ isLoading: false }));
  dispatch(
    sharedDataSlice.actions.setSdModal({
      isOpen: false,
      type: null,
      revisionNumber: [],
    })
  );
  dispatch(
    setToast({
      isOpen: true,
      message: toastMessage,
      onDismiss: () => {
        dispatch(setToast({ isOpen: false }));
        if (navigation) {
          navigation();
        }
      },
    })
  );
};

export const getRecipeData = (state) => state.sharedData.recipeData;
export const getSdUserData = (state) => state.sharedData.sdUserData;
export const getLookupOptionsData = (state) => state.sharedData.lookupOptions;
export const sdModalInfo = (state) => state.sharedData.sdModal;
export const formInputData = (state) => state.sharedData.formInputValues;
export const getProductInfo = (state) => state.sharedData.productData;
export const existingInputData = (state) =>
  state.sharedData.existingInputValues;
export const availableSdInputStateList = (state) =>
  state.sharedData.availableSdInputStates;
export const getClonedFrom = (state) => state.sharedData.clonedFrom;

export const {
  viewShareData,
  createSharedData,
  updateSharedData,
  deleteSharedData,
  setProductData,
  setSdModal,
  setFormInputValues,
  setExistingInputValues,
  setLookupOptions,
  setClonedFrom,
  resetFormInputValues,
} = sharedDataSlice.actions;

export default sharedDataSlice.reducer;

// ---------------------------------------------------------------------------
// Private helpers shared by saveAsDraftActionItem & handleSaveToActionItems
// ---------------------------------------------------------------------------

/** Fetches existing ActionItem for a product, returns [] if not found. */
const fetchExistingActionItem = async (productId) => {
  try {
    const item = await sharedDataApi.getActionItemById(productId);
    return item ? [item] : [];
  } catch {
    return [];
  }
};

  const doesProductExist = async (productId) => {
    const response = await productApi.searchProducts({
      filter: {
        id: { eq: productId },
      },
    });

    return response?.items?.length > 0;
  };

/** Normalises the Reviewer field into an array of email strings. */
const resolveReviewers = (formInputs) =>
  Array.isArray(formInputs.Reviewer)
    ? formInputs.Reviewer
    : formInputs.Reviewer
    ? [formInputs.Reviewer]
    : [];

/**
 * Builds the base fields shared by both create and update payloads for an
 * ActionItem (product-level metadata that rarely changes).
 */
const buildActionItemBaseFields = (productInfo, cloneFromStoreData) => ({
  ProductId: productInfo.id,
  ModelNumber: productInfo.ModelNumber,
  Category: productInfo.Category,
  SubCategory: productInfo.SubCategory,
  Family: productInfo.Family,
  ControlId: productInfo.ControlId,
  ControlType: productInfo.ControlType,
  BtEnabled: productInfo.BtEnabled,
  SdAvailable: productInfo.SdAvailable,
  Recipe: productInfo.Recipe,
  RecipeDescription: productInfo.RecipeDescription,
  StagingVersion: productInfo.StagingVersion,
  ProductionVersion: productInfo.ProductionVersion,
  // Prefer store value, then fall back to product table value (covers multi-user scenario)
  CloneFromProductId: cloneFromStoreData?.id || productInfo?.CloneFromProductId || '',
});

/**
 * Creates or updates an ActionItem.
 * If an existing item is supplied it is updated; otherwise a new one is created.
 */
const createOrUpdateActionItem = async ({
  existingItem,
  productInfo,
  formInputs,
  reviewers,
  status,
  state,
  currentUser,
  cloneFromStoreData,
  extraFields = {},
}) => {
  const now = new Date().toISOString();

  if (existingItem) {
    const updatePayload = {
      input: {
        id: existingItem.id,
        ...buildActionItemBaseFields(productInfo, cloneFromStoreData),
        Input: JSON.stringify(formInputs),
        State: state,
        Status: status,
        CreatedByEmail: currentUser?.email || existingItem.CreatedByEmail || '',
        ReviewerEmail: reviewers[0] || existingItem.ReviewerEmail || currentUser?.email || '',
        ReviewerEmails: reviewers.length > 0 ? reviewers : existingItem.ReviewerEmails || [],
        LastUpdate: now,
        ...extraFields,
      },
    };
    await sharedDataApi.updateActionItems(updatePayload);
  } else {
    const createPayload = {
      input: {
        id: productInfo.id,
        ...buildActionItemBaseFields(productInfo, cloneFromStoreData),
        CreatedByEmail: currentUser?.email || '',
        ReviewerEmail: reviewers[0] || currentUser?.email || '',
        ReviewerEmails: reviewers,
        CreationDate: now,
        LastUpdate: now,
        Input: JSON.stringify(formInputs),
        State: state,
        Status: status,
        Version: 0,
        ...extraFields,
      },
    };
    await sharedDataApi.createActionItem(createPayload);
  }
};

/** Updates the product's State field, logging (not throwing) on failure. */
const updateProductState = async (productInfo, newState) => {
  try {
    const updatedProduct = {
      id: productInfo.id,
      State: newState,
      ModelNumber: productInfo.ModelNumber,
    };
    await productApi.updateProduct({ updatedProduct });
  } catch (err) {
    console.error(`Failed to update product state to ${newState}:`, err);
  }
};

// ---------------------------------------------------------------------------
// Thunks
// ---------------------------------------------------------------------------

/**
 * Pre_Prod back to Staging (Re-assign).
 * Reverts ActionItem, Product, and RecipeInput states from Pre_Prod to Staging.
 *
 * @param {{ actionItem: object, getAllSdUserInput: () => Promise<object[]> }} payload
 */
export const reAssignToStaging =
  ({ actionItem, getAllSdUserInput, onSuccess }) =>
  async (dispatch) => {
    dispatch(setLoading({ isLoading: true }));
    try {
      // 1. Update Product state back to Staging and reset both ack flags
      await productApi.updateProductData({
        input: {
          id: actionItem.ProductId,
          ModelNumber: actionItem.ModelNumber,
          State: sdStates.staging,
          CoolCloudDBAck: false,
          AMSAck: false,
        },
      });

      // 2. Update ActionItem state back to Staging
      await sharedDataApi.updateActionItems({
        input: {
          id: actionItem.id,
          State: sdStates.staging,
        },
      });

      // 3. Find the Pre_Prod RecipeInput and move it back to Staging
      const userInputs = await getAllSdUserInput();
      const preProdEntry = userInputs.find((u) => u.State === sdStates.preProd);
      if (preProdEntry) {
        await sharedDataApi.updateSdUserInputs({
          input: {
            id: preProdEntry.id,
            ModelNumber: actionItem.ModelNumber,
            State: sdStates.staging,
          },
        });
      }

      dispatch(
        setToast({
          isOpen: true,
          message: "Re-assigned to Staging successfully.",
          onDismiss: () => {dispatch(setToast({ isOpen: false })); if (onSuccess) onSuccess();},
        })
      );
    } catch (error) {
      console.error("Re-assign to Staging failed:", error);
      dispatch(
        setToast({
          isOpen: true,
          message: "Failed to re-assign to Staging. Please try again.",
          onDismiss: () => dispatch(setToast({ isOpen: false })),
        })
      );
      throw error;
    } finally {
      dispatch(setLoading({ isLoading: false }));
    }
  };

/**
 * Staging to Pre_Prod when the creator requests production approval.
 *
 * @param {{ actionItem: object, getAllSdUserInput: () => Promise<object[]> }} payload
 */
export const requestProductionApproval =
  ({ actionItem, getAllSdUserInput, onSuccess }) =>
  async (dispatch) => {
    dispatch(setLoading({ isLoading: true }));
    try {
      // 1. Update ActionItem state Pre_Prod
      await sharedDataApi.updateActionItems({
        input: {
          id: actionItem.id,
          State: sdStates.preProd,
        },
      });

      // 2. Update Product state Pre_Prod
      await productApi.updateProductData({
        input: {
          id: actionItem.ProductId,
          ModelNumber: actionItem.ModelNumber,
          State: sdStates.preProd,
        },
      });

      // 3. Find the Staging RecipeInput and move it to Pre_Prod
      const userInputs = await getAllSdUserInput();
      const stagingInput = userInputs.find((u) => u.State === sdStates.staging);
      if (stagingInput) {
        await sharedDataApi.updateSdUserInputs({
          input: {
            id: stagingInput.id,
            ModelNumber: actionItem.ModelNumber,
            State: sdStates.preProd,
          },
        });
      }

      dispatch(
        setToast({
          isOpen: true,
          message: "Production approval requested successfully.",
          onDismiss: () => {dispatch(setToast({ isOpen: false })); if (onSuccess) onSuccess();},
        })
      );
    } catch (error) {
      console.error("Error requesting production approval:", error);
      dispatch(
        setToast({
          isOpen: true,
          message: "Failed to request production approval. Please try again.",
          onDismiss: () => dispatch(setToast({ isOpen: false })),
        })
      );
      throw error;
    } finally {
      dispatch(setLoading({ isLoading: false }));
    }
  };

/** Saves the current form data as a DRAFT ActionItem (create or update). */
export const saveAsDraftActionItem = (onSuccess) => async (dispatch, getState) => {
  dispatch(setLoading({ isLoading: true }));
  try {
    const state = getState();
    const { productData: productInfo, formInputValues: formInputs, clonedFrom: cloneFromStoreData = {} } =
      state.sharedData;
    const currentUser = state.app.user;

    if (!productInfo?.id) {
      dispatch(setToast({ isOpen: true, message: 'Product information not available', onDismiss: () => dispatch(setToast({ isOpen: false })), }));
      return;
    }
      const productExists = await doesProductExist(productInfo.id);
      if (!productExists) {
        dispatch(
          setToast({
            isOpen: true,
            message:
              "This product was deleted by another user. Please refresh the page.",
            onDismiss: () => dispatch(setToast({ isOpen: false })),
          })
        );
        return;
      }

    const [existingItem] = await fetchExistingActionItem(productInfo.id);
    if (
        existingItem &&
        existingItem.Status === actionItemStatus.inReview &&
        existingItem.CreatedByEmail?.toLowerCase() !== currentUser?.email?.toLowerCase()
      ) {
        dispatch(
          setToast({
            isOpen: true,
            message: `This product has already been submitted for review by ${existingItem.CreatedByEmail}. Please refresh the page.`,
            onDismiss: () => dispatch(setToast({ isOpen: false })),
          })
        );
        return;
      }
    const reviewers = resolveReviewers(formInputs);

    await createOrUpdateActionItem({
      existingItem,
      productInfo,
      formInputs,
      reviewers,
      status: actionItemStatus.draft,
      state: sdStates.draft,
      currentUser,
      cloneFromStoreData,
      extraFields: { ReasonForChange: null },
    });

    await updateProductState(productInfo, sdStates.draft);

    // Update Redux store so UI reflects Draft state immediately without a page refresh
    dispatch(sharedDataSlice.actions.setProductData({ ...productInfo, State: sdStates.draft }));

    dispatch(setToast({
      isOpen: true,
      message: 'Saved as Draft',
      onDismiss: () => {
      dispatch(setToast({ isOpen: false }));
      if (onSuccess) onSuccess();
     }
    }));
  } catch (err) {
    console.error('Save as Draft failed:', err);
    dispatch(setToast({
      isOpen: true,
      message: 'Failed to save as Draft',
      onDismiss: () => dispatch(setToast({ isOpen: false })),
    }));
  } finally {
    dispatch(setLoading({ isLoading: false }));
  }
};

/**
 * Thunk: Push to both AMS and CoolCloud Production.
 * Calls AMS first, then CoolCloud only if AMS succeeds.
 * On success: sets Product State=Production + CoolCloudDBAck=true + AMSAck=true,
 * ActionItem State=Production, and RecipeInput State=Production.
 * @param {{ actionItem: object, productData: object, recipeData: object, getAllSdUserInput: () => Promise<object[]> }} payload
 * @returns {{ success: boolean, message: string, recipeId?: string }}
 */
export const pushToProduction =
  ({ actionItem, productData, recipeData, getAllSdUserInput }) =>
  async (dispatch) => {
    dispatch(setLoading({ isLoading: true }));
    try {
      const { executeProductionOperations } = await import("../../services/moveToProductionService");
      const { executeCoolCloudOperations } = await import("../../services/CoolCloudService");
      
      const userInputs = await getAllSdUserInput();
      const recipeId = userInputs[0]?.id;

      let amsSuccess = false;

      // Call AMS Production API FIRST
      try {
        let amsResult = await executeProductionOperations(actionItem, recipeId, productData, recipeData, userInputs);
        if (typeof amsResult === 'string') {
          try { amsResult = JSON.parse(amsResult); } catch (e) {}
        }
        let statusCode = amsResult?.statusCode ? Number(amsResult.statusCode) : null;
        let bodyObj = amsResult?.body;
        if (typeof bodyObj === 'string') {
          try { bodyObj = JSON.parse(bodyObj); } catch (e) {}
        }
        if (statusCode === 200 && bodyObj && (bodyObj.success === true || bodyObj.success === "true")) {
          amsSuccess = true;
        }
        console.log("AMS Production API result:", { statusCode, amsSuccess, amsResult });
      } catch (error) {
        console.error("Error calling AMS Production API:", error);
        amsSuccess = false;
      }

      // If AMS failed, stop here and return error
      if (!amsSuccess) {
        dispatch(setLoading({ isLoading: false }));
        return {
          success: false,
          message: "Push to AMS Production failed. CoolCloud push was not attempted. Please try again."
        };
      }

      // AMS succeeded, now call CoolCloud Production API
      let coolCloudSuccess = false;
      try {
        const userInput = actionItem.Input ? JSON.parse(actionItem.Input) : {};
        const coolCloudResult = await executeCoolCloudOperations(
          actionItem,
          productData,
          recipeData,
          userInput
        );
        console.log("CoolCloud Production API result:", coolCloudResult);
        coolCloudSuccess = !(coolCloudResult && coolCloudResult.error);
      } catch (error) {
        console.error("Error calling CoolCloud Production API:", error);
        coolCloudSuccess = false;
      }

      // Handle results
      if (coolCloudSuccess) {
        // Both APIs succeeded
        dispatch(setLoading({ isLoading: false }));
        return {
          success: true,
          message: "Data has been successfully pushed to CoolCloud and AMS Production.",
          recipeId
        };
      } else {
        // AMS succeeded but CoolCloud failed
        dispatch(setLoading({ isLoading: false }));
        return {
          success: false,
          message: "AMS data successfully pushed. CoolCloud push failed."
        };
      }
    } catch (error) {
      console.error("Push to CoolCloud and AMS Production failed:", error);
      dispatch(setLoading({ isLoading: false }));
      return {
        success: false,
        message: "Push to CoolCloud and AMS Production failed. Please try again or contact support."
      };
    }
  };

